exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".copy2clipboard{cursor:pointer}.code-status{font-weight:700;font-size:1.5em}.p-toast{position:absolute;margin-top:-30px;margin-left:-30px;border-radius:4px;background-color:#333;padding:4px;color:#fff;font-size:.8em}@-webkit-keyframes rainbowFade{0%{color:red}20%{color:#ff8000}40%{color:#000}60%{color:#00f}80%{color:#cf26ff}to{color:red}}@keyframes rainbowFade{0%{color:red}20%{color:#ff8000}40%{color:#000}60%{color:#00f}80%{color:#cf26ff}to{color:red}}.rainbow-text{-webkit-animation:rainbowFade 5s infinite;animation:rainbowFade 5s infinite}", ""]);

// exports
